"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = require("../../elements/button/Button");
var _addToBasketUtils = require("./addToBasketUtils");
var _addToBasketButtonModule = _interopRequireDefault(require("./add-to-basket-button.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["sendToBasket", "onBeforeAdd", "onSuccess", "onError", "shortCtaText", "className", "forceLoading", "isRoundel", "title", "variantId", "skuId", "quantity", "clientId", "path", "customText", "hasHeaderBasketCountEvent", "hasScreenReaderAnnouncement"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var STATE_ACTIVE = 'ACTIVE';
var STATE_ADDING = 'ADDING';
var STATE_SUCCESS = 'SUCCESS';
var STATE_TEXT = {
  ACTIVE: 'Add to your basket',
  ADDING: 'Adding to your basket',
  SUCCESS: 'Added to your basket'
};
var STATE_TEXT_SHORT = {
  ACTIVE: 'Add to basket',
  ADDING: 'Adding to basket',
  SUCCESS: 'Added to basket'
};
var AddToBasketButton = function AddToBasketButton(_ref) {
  var _ref$sendToBasket = _ref.sendToBasket,
    sendToBasket = _ref$sendToBasket === void 0 ? function (_, opts) {
      return (0, _addToBasketUtils.addToBasketRequest)(opts);
    } : _ref$sendToBasket,
    _ref$onBeforeAdd = _ref.onBeforeAdd,
    onBeforeAdd = _ref$onBeforeAdd === void 0 ? function () {
      return Promise.resolve();
    } : _ref$onBeforeAdd,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? undefined : _ref$onSuccess,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? undefined : _ref$onError,
    _ref$shortCtaText = _ref.shortCtaText,
    shortCtaText = _ref$shortCtaText === void 0 ? false : _ref$shortCtaText,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$forceLoading = _ref.forceLoading,
    forceLoading = _ref$forceLoading === void 0 ? false : _ref$forceLoading,
    _ref$isRoundel = _ref.isRoundel,
    isRoundel = _ref$isRoundel === void 0 ? false : _ref$isRoundel,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$variantId = _ref.variantId,
    variantId = _ref$variantId === void 0 ? undefined : _ref$variantId,
    _ref$skuId = _ref.skuId,
    skuId = _ref$skuId === void 0 ? undefined : _ref$skuId,
    _ref$quantity = _ref.quantity,
    quantity = _ref$quantity === void 0 ? 1 : _ref$quantity,
    _ref$clientId = _ref.clientId,
    clientId = _ref$clientId === void 0 ? undefined : _ref$clientId,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '/basket/items' : _ref$path,
    _ref$customText = _ref.customText,
    customText = _ref$customText === void 0 ? undefined : _ref$customText,
    _ref$hasHeaderBasketC = _ref.hasHeaderBasketCountEvent,
    hasHeaderBasketCountEvent = _ref$hasHeaderBasketC === void 0 ? true : _ref$hasHeaderBasketC,
    _ref$hasScreenReaderA = _ref.hasScreenReaderAnnouncement,
    hasScreenReaderAnnouncement = _ref$hasScreenReaderA === void 0 ? true : _ref$hasScreenReaderA,
    rest = _objectWithoutProperties(_ref, _excluded);
  var TEXT = shortCtaText ? STATE_TEXT_SHORT : STATE_TEXT;
  var _useState = (0, _react.useState)(STATE_ACTIVE),
    _useState2 = _slicedToArray(_useState, 2),
    addToBasketState = _useState2[0],
    setAddToBasketState = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    addToBasketErrors = _useState4[0],
    setAddToBasketErrors = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    screenReaderAnnouncement = _useState6[0],
    setScreenReaderAnnouncement = _useState6[1];
  var handleErrors = function handleErrors() {
    var resJson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var partialSuccess = arguments.length > 1 ? arguments[1] : undefined;
    return new Promise(function (resolve) {
      if (!resJson.errors || resJson.errors.length === 0) {
        resolve(resJson);
      } else if (onError) {
        onError(resJson, partialSuccess).then(resolve);
      } else {
        Promise.resolve().then(function () {
          return _interopRequireWildcard(require('./AddToBasketErrors'));
        }).then(function (_ref2) {
          var AddToBasketErrors = _ref2.AddToBasketErrors;
          return setAddToBasketErrors( /*#__PURE__*/(0, _jsxRuntime.jsx)(AddToBasketErrors, {
            errors: resJson.errors,
            showAsWarnings: partialSuccess,
            clearAddToBasketErrors: function clearAddToBasketErrors() {
              setAddToBasketErrors(null);
              resolve(resJson);
            }
          }));
        });
      }
    });
  };
  var handleSuccess = function handleSuccess(resJson) {
    if (hasHeaderBasketCountEvent) {
      (0, _addToBasketUtils.updateHeaderBasketCount)();
    }
    if (hasScreenReaderAnnouncement) {
      setScreenReaderAnnouncement("".concat(title, " added to your basket"));
      setTimeout(function () {
        setScreenReaderAnnouncement(null);
      }, 500);
    }
    if (isRoundel) {
      setAddToBasketState(STATE_SUCCESS);
      setTimeout(function () {
        setAddToBasketState(STATE_ACTIVE);
      }, 1500);
    } else {
      setAddToBasketState(STATE_ACTIVE);
    }
    if (onSuccess) {
      onSuccess(resJson);
    }
  };
  var handleClick = function handleClick(event) {
    setAddToBasketState(STATE_ADDING);
    onBeforeAdd(event, {
      variantId: variantId,
      skuId: skuId,
      quantity: quantity,
      clientId: clientId,
      path: path
    }).then(sendToBasket(event, {
      variantId: variantId,
      skuId: skuId,
      quantity: quantity,
      clientId: clientId,
      path: path
    }).then(function () {
      var resJson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (resJson.errors && resJson.errors.length > 0) {
        Promise.resolve(handleErrors(resJson, true)).then(handleSuccess);
      } else {
        handleSuccess(resJson);
      }
    }, function (resJson) {
      return Promise.resolve(handleErrors(resJson)).then(function () {
        setAddToBasketState(STATE_ACTIVE);
      });
    }));
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.PrimaryButton, _objectSpread(_objectSpread({
      onClick: handleClick,
      className: (0, _classnames2["default"])(className, _addToBasketButtonModule["default"]['c-atb-btn'], _addToBasketButtonModule["default"]['joyfully-bold'], _addToBasketButtonModule["default"]['c-atb-btn--joyfully-bold'], _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _addToBasketButtonModule["default"]['c-atb-btn--roundel'], isRoundel), _addToBasketButtonModule["default"]['c-atb-btn--is-active'], addToBasketState === STATE_ACTIVE), _addToBasketButtonModule["default"]['c-atb-btn--is-adding'], addToBasketState === STATE_ADDING), _addToBasketButtonModule["default"]['c-atb-btn--is-successful'], addToBasketState === STATE_SUCCESS)),
      inverted: isRoundel && [STATE_SUCCESS, STATE_ADDING].includes(addToBasketState),
      submitting: forceLoading || addToBasketState === STATE_ADDING,
      disabled: forceLoading || addToBasketState === STATE_SUCCESS,
      "aria-label": customText || TEXT[addToBasketState]
    }, rest), {}, {
      children: [customText || TEXT['ACTIVE'], /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _addToBasketButtonModule["default"]['visually-hidden'],
        children: ", ".concat(title)
      })]
    })), addToBasketErrors, screenReaderAnnouncement && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      "aria-live": "assertive",
      role: "status",
      className: _addToBasketButtonModule["default"]['visually-hidden'],
      children: screenReaderAnnouncement
    })]
  });
};
AddToBasketButton.propTypes = {
  /** Class to apply to the button */
  className: _propTypes["default"].string,
  /** Function to be called before sending the ATB request. Should return a promise. */
  onBeforeAdd: _propTypes["default"].func,
  /** Function to be called when add to basket is clicked. Should return a promise containing a list of any errors. */
  sendToBasket: _propTypes["default"].func,
  /** Flag to use short version text for CTA button */
  shortCtaText: _propTypes["default"].bool,
  /** Flag to force show loading state (ATB->QV Lazy loading) */
  forceLoading: _propTypes["default"].bool,
  /** Flag to show roundel button */
  isRoundel: _propTypes["default"].bool,
  /** Product title (used for screen reader text) */
  title: _propTypes["default"].string.isRequired,
  /** Success callback (also handles partial success) */
  onSuccess: _propTypes["default"].func,
  /** Error callback */
  onError: _propTypes["default"].func,
  /** Product variantId */
  variantId: _propTypes["default"].string,
  /** Product skuId */
  skuId: _propTypes["default"].string,
  /** Quantity to add */
  quantity: _propTypes["default"].number,
  /** ClientId for the basket services */
  clientId: _propTypes["default"].string,
  /** Basket endpoint (useful to override for local development) */
  path: _propTypes["default"].string,
  /** Custom text to use in the button */
  customText: _propTypes["default"].string,
  /** Flag to prevent triggering the header basket count event */
  hasHeaderBasketCountEvent: _propTypes["default"].bool,
  /** Flag to prevent screen reader announcements */
  hasScreenReaderAnnouncement: _propTypes["default"].bool
};
var _default = exports["default"] = AddToBasketButton;